(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-collection-carousel')) {
    customElements.define('featured-collection-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.track = this.querySelector('[data-carousel-track]');
        this.previous = this.querySelector('[data-carousel-previous]');
        this.next = this.querySelector('[data-carousel-next]');
        const signal = this.controller.signal;

        this.previous?.addEventListener('click', () => this.move(-1), { signal });
        this.next?.addEventListener('click', () => this.move(1), { signal });
        this.track?.addEventListener('scroll', () => this.updateArrows(), { passive: true, signal });
        this.addEventListener('click', (event) => this.handleClick(event), { signal });
        this.addEventListener('submit', (event) => this.handleSubmit(event), { signal });

        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        if (this.track) this.resizeObserver.observe(this.track);
        requestAnimationFrame(() => this.updateArrows());
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }

      move(direction) {
        if (!this.track) return;
        const card = this.track.querySelector('.fc-card');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.85;
        this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      updateArrows() {
        if (!this.track || !this.previous || !this.next) return;
        const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.previous.hidden = !hasOverflow;
        this.next.hidden = !hasOverflow;
        if (!hasOverflow) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
      }

      handleClick(event) {
        const opener = event.target.closest('[data-quick-open]');
        if (opener) {
          const dialog = this.querySelector(`#${CSS.escape(opener.dataset.quickOpen)}`);
          dialog?.showModal();
          return;
        }

        const closer = event.target.closest('[data-quick-close]');
        if (closer) {
          closer.closest('dialog')?.close();
          return;
        }

        if (event.target instanceof HTMLDialogElement) {
          const rect = event.target.getBoundingClientRect();
          const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
          if (outside) event.target.close();
        }
      }

      async handleSubmit(event) {
        const form = event.target.closest('[data-quick-form]');
        if (!form) return;
        event.preventDefault();

        const button = form.querySelector('[type="submit"]');
        const status = form.querySelector('[data-quick-status]');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (status) status.textContent = '';

        try {
          const endpoint = form.action.endsWith('.js') ? form.action : `${form.action}.js`;
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          const item = await response.json();
          if (!response.ok) throw new Error(item.description || item.message || 'Unable to add this item.');

          button.classList.add('is-success');
          const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
            headers: { Accept: 'application/json' }
          });
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart, item } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, open: true } }));

          if (this.dataset.afterAdd === 'cart') {
            window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
            return;
          }

          form.closest('dialog')?.close();
          setTimeout(() => button.classList.remove('is-success'), 1800);
        } catch (error) {
          if (status) status.textContent = error.message;
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();
})();
